import { IGroup } from '@/api/types'

export function addGroupType(items: IGroup[], group_type: string): IGroup[] {
  return items.map((item) => ({ ...item, group_type }))
}
